import { Token, IAuthService } from 'types/services/auth';

export class AuthMockService implements IAuthService {
  constructor(private token: Token) {}

  login = () => Promise.resolve(this.token);
  refreshToken = () => Promise.resolve(this.token);
}
